import { IAppState } from '../../common/state';
import { PERSONAL_RANKING } from '../../constants/experiments';

export function selectPersonalRankingAbGroupName({ abUseExperiments }: IAppState) {
  const experiment = abUseExperiments.find(e => e.experimentName === PERSONAL_RANKING);

  if (!experiment) {
    return null;
  }

  return experiment.groupName;
}
